<template>
    <Select :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
        <SelectTrigger class="w-[160px] h-9">
            <SelectValue :placeholder="selectedLabel" />
        </SelectTrigger>
        <SelectContent>
            <SelectItem
                v-for="role in roles"
                :key="role.value"
                :value="role.value"
            >
                <div class="flex flex-col py-1">
                    <span class="text-sm font-medium">{{ role.label }}</span>
                    <span v-if="role.description" class="text-xs text-muted-foreground leading-snug">
                        {{ role.description }}
                    </span>
                </div>
            </SelectItem>
        </SelectContent>
    </Select>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'

interface RoleOption {
    label: string
    value: string
    description?: string
}

const props = defineProps<{
    modelValue: string
    roles: RoleOption[]
}>()

defineEmits<{
    'update:modelValue': [value: string]
}>()

const selectedLabel = computed(() => {
    const role = props.roles.find((r) => r.value === props.modelValue)
    return role?.label ?? props.modelValue
})
</script>
